// This file contains conversion functions needed to take data packaged in types
// and convert them to formats the the UI can use.

import { Allergen, Pricing } from "@dining/api-client";
import { useSelector } from "react-redux";
import { currencySelector } from "../selectors/diningSelector";

// This takes pricing data (or an array of pricing data) and returns it as a formatted string.
export const pricingDataToString = (pricingData: Pricing | Pricing[] | undefined): string => {
  const currentCurrency = useSelector(currencySelector);
  let pricingString = "";
  if (Array.isArray(pricingData)) {
    pricingData.forEach((price, x) => {
      pricingString += currentCurrency.currency + price.amount;
      if (pricingData[x + 1]) {
        pricingString += " / ";
      }
    });
  } else if (pricingData?.amount) {
    pricingString += currentCurrency.currency + pricingData.amount;
  } else if (!pricingData) {
    pricingString = "Prices vary.";
  }
  return pricingString;
};

// This takes an array of allergen data and returns it as a formatted string.
export const allergenDataToString = (allergenData?: Allergen[]): string | undefined => {
  return allergenData?.map((a) => a.name ?? "").join(", ");
};

export const getPriceString = (pricingData?: Pricing): string => {
  const currentCurrency = useSelector(currencySelector);
  if (pricingData) {
    if (pricingData.amount === 0 || (pricingData.amount && pricingData.amount < 0)) {
      return "";
    } else {
      return `${currentCurrency.currency || ""}${pricingData.amount}`;
    }
  } else {
    return "";
  }
};
